import dayjs from '../../../../shared/services/dayjs.js';
import { Roles } from '../../../../../domain/konstanten/Roles.js';
import stammdatenService from '../services/stammdatenService.js';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';

window.myHandlers = window.myHandlers || {};
window.myHandlers.rechnungSchulungHinzufuegen = rechnungSchulungHinzufuegen;
window.myHandlers.rechnungSchulungEntfernen = rechnungSchulungEntfernen;
window.myHandlers.rechnungSchulungNotiz = rechnungSchulungNotiz;
window.myHandlers.rechnungSchulungLink = rechnungSchulungLink;
window.myHandlers.rechnungLinkOeffnen = rechnungLinkOeffnen;
window.myHandlers.rechnungMonatWechsel = rechnungMonatWechsel;
window.myHandlers.rechnungMonatPick = rechnungMonatPick;

const SCHULUNG_PREIS = 125;
const MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

// Modulzustand: der intern gewählte Monat (unabhängig vom App-Monat), die je
// Betriebsstätte ermittelten Mitarbeiterzahlen (read-only) und ob der aktuelle
// Benutzer (Rolle Account-Admin) Änderungen vornehmen darf.
const rechnung = { monat: null, minMonat: null, maxMonat: null, betriebe: [], sofortmeldungen: 0, editable: false, configTimer: null, schulungTimer: null };

/* ----------------------------- helpers ----------------------------- */
const eur = (n) => (Number(n) || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
const feld = (label) => document.querySelector(`#vw-rechnung [aria-label="${label}"]`);
const numVal = (label) => Number(feld(label)?.value) || 0;
const checkVal = (label) => !!feld(label)?.checked;
const textVal = (label) => feld(label)?.value ?? '';
const zeitraumStr = () => (rechnung.monat ? rechnung.monat.format('YYYY-MM-DD') : '');

// Wandelt "jjjj-mm" in einen dayjs-Monatsanfang um (leitet sich vom bestehenden
// dayjs-Objekt ab, daher kein zusätzlicher Import nötig). Ohne gültige Angabe null.
function monatAus(str) {
    if (!str || !rechnung.monat) return null;
    const [jahr, monat] = str.split('-').map(Number);
    if (!jahr || !monat) return null;
    return rechnung.monat.year(jahr).month(monat - 1).startOf('month');
}

// Setzt die Monatsgrenzen: Obergrenze = aktueller App-Monat, Untergrenze = erster
// Abrechnungsmonat (falls angegeben). Aktualisiert min/max des Pickers.
function setzeMonatsGrenzen() {
    rechnung.minMonat = monatAus(textVal('r-ErsterAbrechnungsmonat'));
    const input = document.getElementById('rechnung-monat-input');
    if (input) {
        input.max = rechnung.maxMonat ? rechnung.maxMonat.format('YYYY-MM') : '';
        input.min = rechnung.minMonat ? rechnung.minMonat.format('YYYY-MM') : '';
    }
    zeigeMonat();
}

// Zeigt den intern gewählten Monat im Monats-Input an und sperrt die Pfeile an den
// Monatsgrenzen (kein Wechsel in die Zukunft bzw. vor den ersten Abrechnungsmonat).
function zeigeMonat() {
    const input = document.getElementById('rechnung-monat-input');
    if (input && rechnung.monat) input.value = rechnung.monat.format('YYYY-MM');
    const next = document.getElementById('rechnung-monat-next');
    if (next) next.disabled = !!rechnung.maxMonat && rechnung.monat.valueOf() >= rechnung.maxMonat.valueOf();
    const prev = document.getElementById('rechnung-monat-prev');
    if (prev) prev.disabled = !!rechnung.minMonat && rechnung.monat.valueOf() <= rechnung.minMonat.valueOf();
}

// Lädt Konditionen, Schulungen und Mitarbeiterzahlen des aktuell gewählten Monats und
// bestückt die Oberfläche neu. Wird beim Öffnen und bei jedem Monatswechsel aufgerufen.
async function bestueckeMonat() {
    zeigeMonat();
    const daten = await stammdatenService.leseRechnung(zeitraumStr()) || {};
    rechnung.betriebe = daten.Betriebe || [];
    zeigeSofortmeldungen(daten.SofortmeldungenMonat);

    // Skalare Konfiguration (des Monats bzw. Übernahme/Default) in die Felder schreiben.
    setFeld('r-ErsterAbrechnungsmonat', daten.ErsterAbrechnungsmonat);
    setFeld('r-PreisProMA', daten.PreisProMA);
    setCheck('r-Sofortmeldung', daten.Sofortmeldung);
    setFeld('r-KostenProSofortmeldung', daten.KostenProSofortmeldung);
    setCheck('r-EAU', daten.EAU);
    setFeld('r-KostenProEAU', daten.KostenProEAU);
    setFeld('r-OnboardingMA', daten.OnboardingMA);
    setFeld('r-OnboardingKostenProMA', daten.OnboardingKostenProMA);
    setFeld('r-Rabatt', daten.Rabatt);
    setFeld('r-RabattEinheit', daten.RabattEinheit || '%');
    setFeld('r-Mengenrabatt', daten.Mengenrabatt);
    setFeld('r-Mindestabnahme', daten.Mindestabnahme);
    setFeld('r-Pauschale', daten.Pauschale);

    setzeMonatsGrenzen();
    renderBetriebe();
    renderSchulungen(daten.Schulungen || []);
    setzeBearbeitbarkeit();
    berechne();
}

// Wechselt den intern gewählten Monat per Pfeil (ohne den App-Monat zu ändern).
async function rechnungMonatWechsel(delta) {
    if (!rechnung.monat) return;
    const ziel = rechnung.monat.add(delta, 'month');
    // Kein Wechsel in einen zukünftigen Monat oder vor den ersten Abrechnungsmonat.
    if (rechnung.maxMonat && ziel.valueOf() > rechnung.maxMonat.valueOf()) return;
    if (rechnung.minMonat && ziel.valueOf() < rechnung.minMonat.valueOf()) return;
    rechnung.monat = ziel;
    await bestueckeMonat();
}

// Setzt den intern gewählten Monat über den Monats-Picker ("jjjj-mm").
async function rechnungMonatPick(element) {
    if (!rechnung.monat || !element.value) return;
    const [jahr, monat] = element.value.split('-').map(Number);
    let ziel = rechnung.monat.year(jahr).month(monat - 1).startOf('month');
    // Auf den gültigen Bereich begrenzen (erster Abrechnungsmonat … aktueller Monat).
    if (rechnung.maxMonat && ziel.valueOf() > rechnung.maxMonat.valueOf()) ziel = rechnung.maxMonat;
    if (rechnung.minMonat && ziel.valueOf() < rechnung.minMonat.valueOf()) ziel = rechnung.minMonat;
    rechnung.monat = ziel;
    await bestueckeMonat();
}

/**
 * Lädt die Rechnungsansicht: initialisiert Monat/Grenzen, verdrahtet die Eingaben einmalig
 * und bestückt die Oberfläche mit den Daten des aktuellen Monats.
 */
export async function ladeRechnung() {
    rechnung.editable = window.myVars.UserRoles.includes(Roles.AccountAdmin);
    // Beim Öffnen wird der aktuell in der App gewählte Monat übernommen. Danach
    // ist der Monat dieser Ansicht unabhängig und wird nur intern gewechselt.
    rechnung.monat = window.myVars.aktuellesMonatsDatum?.startOf('month') ?? null;
    // Zukünftige Monate sperren: der aktuelle Monat ist die Obergrenze.
    rechnung.maxMonat = dayjs.tz(new Date(), "Europe/Berlin").startOf('month') ?? null;
    verdrahteEingaben();
    await bestueckeMonat();
}

function setFeld(label, value) {
    const el = feld(label);
    if (el && value !== undefined && value !== null) el.value = value;
}
function setCheck(label, value) {
    const el = feld(label);
    if (el) el.checked = !!value;
}

/**
 * Rendert die Mitarbeiterzahlen je Betriebsstätte (nur Anzeige) inkl. Summenzeile.
 */
function renderBetriebe() {
    const tbody = document.getElementById('rechnung-betriebe');
    if (!tbody) return;
    tbody.innerHTML = '';
    let aktivGesamt = 0;
    let abgerechnetGesamt = 0;
    let nichtGesamt = 0;
    if (rechnung.betriebe.length === 0) {
        tbody.innerHTML = '<tr><td colspan="5" class="rechnung-empty">Keine Mitarbeiterdaten vorhanden.</td></tr>';
    }
    rechnung.betriebe.forEach((bs) => {
        aktivGesamt += bs.Aktiv;
        abgerechnetGesamt += bs.Abgerechnet;
        nichtGesamt += bs.NichtAbgerechnet;
        const tr = document.createElement('tr');
        tr.innerHTML = `<td>${bs.Name || ''}</td><td>${bs.Aktiv}</td><td>${bs.NichtAbgerechnet}</td><td>${bs.Abgerechnet}</td><td class="rechnung-betrag"></td>`;
        tbody.appendChild(tr);
    });
    document.getElementById('rechnung-aktiv-total').innerText = aktivGesamt;
    document.getElementById('rechnung-abgerechnet-total').innerText = abgerechnetGesamt;
    document.getElementById('rechnung-nichtabgerechnet-total').innerText = nichtGesamt;
    aktualisiereBetraege();
}

// Aktualisiert die Euro-Spalte je Betriebsstätte (Abgerechnet × Preis pro MA) und die Summe.
// Greift die Mindestabnahme (Mindest-MA-Anzahl), wird die Summe darauf angehoben und ein
// erklärender Hinweis angezeigt.
function aktualisiereBetraege() {
    const preis = numVal('r-PreisProMA');
    const mindestabnahme = numVal('r-Mindestabnahme');
    const zellen = document.querySelectorAll('#rechnung-betriebe .rechnung-betrag');
    let abgerechnetGesamt = 0;
    rechnung.betriebe.forEach((bs, i) => {
        abgerechnetGesamt += bs.Abgerechnet;
        if (zellen[i]) zellen[i].innerText = eur(bs.Abgerechnet * preis);
    });
    const billedMA = Math.max(abgerechnetGesamt, mindestabnahme);
    const greift = mindestabnahme > abgerechnetGesamt;
    document.getElementById('rechnung-betrag-total').innerText = eur(billedMA * preis);

    // In der Summenzeile die abgerechnete Anzahl auf die Mindestabnahme anheben, falls diese greift.
    const abgTotal = document.getElementById('rechnung-abgerechnet-total');
    if (abgTotal) {
        abgTotal.innerText = billedMA;
        abgTotal.title = greift ? `Mindestabnahme (${mindestabnahme}) statt ${abgerechnetGesamt} abgerechnet` : '';
    }

    // Hinweis anzeigen, wenn die Mindestabnahme die abgerechnete Anzahl übersteigt.
    const hinweis = document.getElementById('rechnung-mindestabnahme-hinweis');
    if (hinweis) {
        hinweis.style.display = greift ? 'block' : 'none';
        if (greift) {
            hinweis.innerText = `Mindestabnahme von ${mindestabnahme} MA angewendet (statt ${abgerechnetGesamt} abgerechnet).`;
        }
    }
}

/**
 * Rendert die Schulungszeilen aus den geladenen Daten.
 */
function renderSchulungen(schulungen) {
    const container = document.getElementById('rechnung-schulungen');
    container.innerHTML = '';
    schulungen.forEach((s) => container.appendChild(erstelleSchulungZeile(s)));
    aktualisiereSchulungenAnsicht();
}

function erstelleSchulungZeile(schulung = { Bezeichnung: '', Datum: '', Stunden: 1, Betrag: SCHULUNG_PREIS, Link: '' }) {
    const template = document.querySelector('#vw-rechnung [rechnung-schulung-template]');
    const zeile = template.content.cloneNode(true).children[0];
    // Alle Schulungen werden als Gesamtübersicht angezeigt (Datum frei wählbar); nur die
    // im gewählten Monat liegenden fließen in die Monatssumme ein.
    zeile.querySelector('[aria-label="r-schulung-Datum"]').value = schulung.Datum ?? '';
    zeile.querySelector('[aria-label="r-schulung-Bezeichnung"]').value = schulung.Bezeichnung ?? '';
    zeile.querySelector('[aria-label="r-schulung-Stunden"]').value = schulung.Stunden ?? 0;
    zeile.querySelector('[aria-label="r-schulung-Betrag"]').value = schulung.Betrag ?? SCHULUNG_PREIS;
    zeile.querySelector('[aria-label="r-schulung-Link"]').value = schulung.Link ?? '';
    zeile.querySelector('[aria-label="r-schulung-Notiz"]').value = schulung.Notiz ?? '';
    aktualisiereLinkButton(zeile.querySelector('.rechnung-link-btn'), schulung.Link);
    aktualisiereNotizButton(zeile.querySelector('.rechnung-notiz-btn'), schulung.Notiz);
    // Ersteller/Erstelldatum durchreichen (per Backend gesetzt) und anzeigen.
    zeile.dataset.erstelltVon = schulung.ErstelltVon ?? '';
    zeile.dataset.erstelltDatum = schulung.ErstelltDatum ?? '';
    zeigeSchulungMeta(zeile, schulung);
    if (!rechnung.editable) {
        // Link-/Notiz-Buttons bleiben aktiv (Ansehen/Öffnen), der Rest wird deaktiviert.
        zeile.querySelectorAll('input, button:not(.rechnung-mini-btn)').forEach((el) => { el.disabled = true; });
        // Für nur-lesende Benutzer (z.B. Sachbearbeiter) den Löschen-Button ausblenden.
        zeile.querySelector('.rechnung-schulung-del-btn')?.remove();
    }
    // Eingaben werden zentral per Delegation am Container behandelt (siehe verdrahteEingaben).
    return zeile;
}

/**
 * Fügt eine neue (leere) Schulung mit Standardpreis hinzu.
 */
function rechnungSchulungHinzufuegen() {
    if (!rechnung.editable) return;
    document.getElementById('rechnung-schulungen').appendChild(erstelleSchulungZeile());
    aktualisiereSchulungenAnsicht();
    berechne();
    speichereSchulungenDebounced();
}

/**
 * Entfernt die zugehörige Schulungszeile.
 */
function rechnungSchulungEntfernen(button) {
    if (!rechnung.editable) return;
    button.closest('.rechnung-schulung-row')?.remove();
    aktualisiereSchulungenAnsicht();
    berechne();
    speichereSchulungenDebounced();
}

/**
 * Öffnet den Notiz-Dialog für eine Schulung. Account-Admin können bearbeiten,
 * nur-lesende Benutzer sehen die Notiz schreibgeschützt.
 */
async function rechnungSchulungNotiz(button) {
    const zeile = button.closest('.rechnung-schulung-row');
    const notizInput = zeile.querySelector('[aria-label="r-schulung-Notiz"]');
    const textarea = document.getElementById('rechnung-notiz-dialog-text');
    textarea.value = notizInput.value || '';
    textarea.readOnly = !rechnung.editable;
    const saveBtn = document.getElementById('rechnung-notiz-dialog-save');
    if (saveBtn) saveBtn.style.display = rechnung.editable ? '' : 'none';

    const result = await SystemDialogService.instance.displayAsync('rechnung-notiz-dialog');
    if (result?.success && rechnung.editable) {
        notizInput.value = textarea.value;
        aktualisiereNotizButton(button, textarea.value);
        speichereSchulungenDebounced();
    }
}

// Hebt den Notiz-Button hervor, wenn eine Notiz vorhanden ist, und zeigt sie als Tooltip.
function aktualisiereNotizButton(button, wert) {
    if (!button) return;
    const vorhanden = !!(wert && String(wert).trim());
    button.classList.toggle('has-notiz', vorhanden);
    button.title = vorhanden ? 'Notizen ansehen' : 'Notiz hinzufügen';
}

/**
 * Öffnet den Link-Dialog für eine Schulung. Account-Admin können bearbeiten,
 * nur-lesende Benutzer sehen den Link schreibgeschützt und können ihn öffnen.
 */
async function rechnungSchulungLink(button) {
    const zeile = button.closest('.rechnung-schulung-row');
    const linkInput = zeile.querySelector('[aria-label="r-schulung-Link"]');
    // Nur-lesende Benutzer (z.B. Sachbearbeiter) öffnen den Link direkt per Klick.
    if (!rechnung.editable) {
        oeffneLink(linkInput.value);
        return;
    }
    const input = document.getElementById('rechnung-link-dialog-text');
    input.value = linkInput.value || '';
    const result = await SystemDialogService.instance.displayAsync('rechnung-link-dialog');
    if (result?.success) {
        linkInput.value = input.value;
        aktualisiereLinkButton(button, input.value);
        speichereSchulungenDebounced();
    }
}

// Öffnet den im Link-Dialog eingegebenen Link in neuem Tab.
function rechnungLinkOeffnen() {
    oeffneLink(document.getElementById('rechnung-link-dialog-text').value);
}

// Öffnet einen Link (ergänzt fehlendes https://) in einem neuen Tab.
function oeffneLink(wert) {
    if (!wert || !wert.trim()) return;
    const href = /^https?:\/\//i.test(wert) ? wert : `https://${wert}`;
    window.open(href, '_blank', 'noopener');
}

// Hebt den Link-Button hervor, wenn ein Link vorhanden ist.
function aktualisiereLinkButton(button, wert) {
    if (!button) return;
    const vorhanden = !!(wert && String(wert).trim());
    button.classList.toggle('has-link', vorhanden);
    button.title = vorhanden ? (rechnung.editable ? 'Link bearbeiten' : 'Link öffnen') : 'Link hinzufügen';
}

function leseSchulungen() {
    return [...document.querySelectorAll('#rechnung-schulungen .rechnung-schulung-row')].map((zeile) => ({
        Datum: zeile.querySelector('[aria-label="r-schulung-Datum"]').value,
        Bezeichnung: zeile.querySelector('[aria-label="r-schulung-Bezeichnung"]').value,
        Stunden: Number(zeile.querySelector('[aria-label="r-schulung-Stunden"]').value) || 0,
        Betrag: Number(zeile.querySelector('[aria-label="r-schulung-Betrag"]').value) || 0,
        Link: zeile.querySelector('[aria-label="r-schulung-Link"]').value,
        Notiz: zeile.querySelector('[aria-label="r-schulung-Notiz"]').value,
        ErstelltVon: zeile.dataset.erstelltVon || '',
        ErstelltDatum: zeile.dataset.erstelltDatum || '',
    }));
}

// Zeigt "erstellt von … · Datum" unter der Schulung – nur für Account-Admin.
function zeigeSchulungMeta(zeile, schulung) {
    const meta = zeile.querySelector('.rechnung-schulung-meta');
    if (!meta) return;
    if (!rechnung.editable || !schulung.ErstelltDatum) {
        meta.style.display = 'none';
        meta.innerText = '';
        return;
    }
    const datum = new Date(schulung.ErstelltDatum).toLocaleDateString('de-DE');
    meta.style.display = 'block';
    meta.innerText = schulung.ErstelltVon ? `erstellt von ${schulung.ErstelltVon} · ${datum}` : `erstellt am ${datum}`;
}

function aktualisiereSchulungenAnsicht() {
    const anzahl = document.querySelectorAll('#rechnung-schulungen .rechnung-schulung-row').length;
    const empty = document.getElementById('rechnung-schulungen-empty');
    if (empty) empty.style.display = anzahl === 0 ? 'block' : 'none';
}

/**
 * Liest die aktuelle Konfiguration aus den Feldern.
 */
function leseConfig() {
    return {
        ErsterAbrechnungsmonat: textVal('r-ErsterAbrechnungsmonat'),
        PreisProMA: numVal('r-PreisProMA'),
        Sofortmeldung: checkVal('r-Sofortmeldung'),
        KostenProSofortmeldung: numVal('r-KostenProSofortmeldung'),
        EAU: checkVal('r-EAU'),
        KostenProEAU: numVal('r-KostenProEAU'),
        OnboardingMA: numVal('r-OnboardingMA'),
        OnboardingKostenProMA: numVal('r-OnboardingKostenProMA'),
        Rabatt: numVal('r-Rabatt'),
        RabattEinheit: textVal('r-RabattEinheit'),
        Mengenrabatt: numVal('r-Mengenrabatt'),
        Mindestabnahme: numVal('r-Mindestabnahme'),
        Pauschale: numVal('r-Pauschale'),
    };
}

/**
 * Berechnet und zeigt die geschätzte Monatssumme sowie die Schulungssumme.
 */
function berechne() {
    const config = leseConfig();

    // Gesamtbetrag je Schulung = Stunden × Betrag pro Stunde. Nur die im gewählten
    // Monat liegenden Schulungen fließen in die Monatssumme ein.
    let schulungenMonat = 0;
    document.querySelectorAll('#rechnung-schulungen .rechnung-schulung-row').forEach((zeile) => {
        const stunden = Number(zeile.querySelector('[aria-label="r-schulung-Stunden"]').value) || 0;
        const betragProStunde = Number(zeile.querySelector('[aria-label="r-schulung-Betrag"]').value) || 0;
        const datum = zeile.querySelector('[aria-label="r-schulung-Datum"]').value;
        const gesamt = stunden * betragProStunde;
        zeile.querySelector('[aria-label="r-schulung-Gesamt"]').value = eur(gesamt);
        if (istImMonat(datum)) schulungenMonat += gesamt;
    });
    // In-Monat-Schulungen zwischen Tabellensumme und Monatssumme ausweisen –
    // nur, wenn es im gewählten Monat eine Schulung gibt.
    const schulungenZeile = document.getElementById('rechnung-schulungen-zeile');
    if (schulungenZeile) schulungenZeile.style.display = schulungenMonat > 0 ? 'flex' : 'none';
    document.getElementById('rechnung-schulungen-monat-label').innerText = `+ Schulungen (${monatsName()})`;
    document.getElementById('rechnung-schulungen-monat-summe').innerText = eur(schulungenMonat);

    const abgerechnetGesamt = rechnung.betriebe.reduce((summe, bs) => summe + bs.Abgerechnet, 0);
    const billedMA = Math.max(abgerechnetGesamt, config.Mindestabnahme);
    const base = billedMA * config.PreisProMA;
    // Rabatt ist ein Rabatt pro MA: als % wirkt er je MA (= % auf die Basis), als €
    // wird der Euro-Betrag je abgerechnetem MA abgezogen.
    const rabattAbzug = config.RabattEinheit === '%' ? base * config.Rabatt / 100 : config.Rabatt * billedMA;
    const afterRabatt = Math.max(base - rabattAbzug, 0);
    // Rabatt-Abzug als eigene Zeile ausweisen (nur wenn vorhanden).
    const rabattZeile = document.getElementById('rechnung-rabatt-zeile');
    if (rabattZeile) {
        rabattZeile.style.display = rabattAbzug > 0 ? 'flex' : 'none';
        document.getElementById('rechnung-rabatt-label').innerText = `− Rabatt (${config.Rabatt.toLocaleString('de-DE')} ${config.RabattEinheit} pro MA)`;
        document.getElementById('rechnung-rabatt-summe').innerText = eur(rabattAbzug);
    }
    const afterMenge = afterRabatt - afterRabatt * config.Mengenrabatt / 100;

    // Pauschalpreis als eigene Zeile ausweisen (nur wenn vorhanden); kommt zusätzlich
    // zur Preis-pro-MA-Berechnung zur Monatssumme hinzu.
    const pauschaleZeile = document.getElementById('rechnung-pauschale-zeile');
    if (pauschaleZeile) {
        pauschaleZeile.style.display = config.Pauschale > 0 ? 'flex' : 'none';
        document.getElementById('rechnung-pauschale-summe').innerText = eur(config.Pauschale);
    }

    const onboardingKosten = config.OnboardingMA * config.OnboardingKostenProMA;
    document.getElementById('rechnung-onboarding-summe').value = eur(onboardingKosten);
    // Onboarding (Grundeinrichtung) als eigene Zeile ausweisen (nur wenn vorhanden).
    const onboardingZeile = document.getElementById('rechnung-onboarding-zeile');
    if (onboardingZeile) {
        onboardingZeile.style.display = onboardingKosten > 0 ? 'flex' : 'none';
        document.getElementById('rechnung-onboarding-label').innerText = `+ Onboarding (${config.OnboardingMA} MA × ${config.OnboardingKostenProMA.toLocaleString('de-DE')} €)`;
        document.getElementById('rechnung-onboarding-zeile-summe').innerText = eur(onboardingKosten);
    }
    aktualisiereBetraege();

    // Sofortmeldungen: Anzahl im Monat × Kosten pro Sofortmeldung. Wird immer angezeigt,
    // auch bei 0 € (kostenlos).
    const sofortKosten = rechnung.sofortmeldungen * config.KostenProSofortmeldung;
    document.getElementById('rechnung-sofort-label').innerText = `+ Sofortmeldungen (${rechnung.sofortmeldungen} Stk. × ${config.KostenProSofortmeldung.toLocaleString('de-DE')} €)`;
    document.getElementById('rechnung-sofort-summe').innerText = eur(sofortKosten);

    const monatsSumme = afterMenge + config.Pauschale + onboardingKosten + schulungenMonat + sofortKosten;
    document.getElementById('rechnung-monatssumme').innerText = eur(monatsSumme);

    // Angewandter Satz (Preis pro abgerechnetem MA) als Zusatzinfo anzeigen.
    document.getElementById('rechnung-rate').innerText = `(${config.PreisProMA.toLocaleString('de-DE')} € pro MA)`;
}

// Name des aktuell gewählten Monats (z.B. "Mai 2026").
function monatsName() {
    return rechnung.monat ? `${MONATE[rechnung.monat.month()]} ${rechnung.monat.year()}` : '';
}

// Merkt sich die Anzahl erfolgreicher Sofortmeldungen des Monats und zeigt sie neben dem Label.
function zeigeSofortmeldungen(anzahl) {
    rechnung.sofortmeldungen = Number(anzahl) || 0;
    const el = document.getElementById('rechnung-sofortmeldungen-count');
    if (el) el.innerText = `(${rechnung.sofortmeldungen} in ${monatsName()})`;
}

// Prüft, ob ein Datum im aktuell gewählten Monat liegt. Akzeptiert das ISO-Format
// "jjjj-mm-tt" (aus dem Date-Input) sowie das deutsche Format "tt.mm.jjjj" (Altdaten).
function istImMonat(datumStr) {
    if (!rechnung.monat || !datumStr) return false;
    let jahr;
    let monat;
    const iso = datumStr.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    const de = datumStr.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (iso) {
        jahr = Number(iso[1]);
        monat = Number(iso[2]) - 1;
    } else if (de) {
        jahr = Number(de[3]);
        monat = Number(de[2]) - 1;
    } else {
        return false;
    }
    return monat === rechnung.monat.month() && jahr === rechnung.monat.year();
}

/**
 * Verdrahtet die Eingabefelder der Basis-Konfiguration (nur für Account-Admin wirksam).
 */
function verdrahteEingaben() {
    if (!rechnung.editable) return;
    const labels = ['r-ErsterAbrechnungsmonat', 'r-PreisProMA', 'r-Sofortmeldung', 'r-KostenProSofortmeldung', 'r-EAU',
        'r-KostenProEAU', 'r-OnboardingMA', 'r-OnboardingKostenProMA', 'r-Rabatt', 'r-RabattEinheit', 'r-Mengenrabatt', 'r-Mindestabnahme', 'r-Pauschale'];
    labels.forEach((label) => {
        const el = feld(label);
        if (!el) return;
        // Property-Zuweisung statt addEventListener: idempotent, falls ladeRechnung
        // bei einem Monatswechsel erneut auf denselben Feldern läuft. setzeMonatsGrenzen
        // hält die Picker-Grenzen aktuell, wenn der erste Abrechnungsmonat geändert wird.
        el.oninput = () => { setzeMonatsGrenzen(); berechne(); speichereConfigDebounced(); };
        el.onchange = () => { setzeMonatsGrenzen(); berechne(); speichereConfigDebounced(); };
    });

    // Schulungen zentral per Event-Delegation: jede Eingabe in einer (auch neu
    // hinzugefügten) Schulungszeile aktualisiert die Summe und speichert verzögert.
    const schulungenContainer = document.getElementById('rechnung-schulungen');
    if (schulungenContainer) {
        schulungenContainer.oninput = () => { berechne(); speichereSchulungenDebounced(); };
    }
}

/**
 * Deaktiviert alle Eingaben, wenn der Benutzer keine Account-Admin Rolle besitzt (nur lesen).
 */
function setzeBearbeitbarkeit() {
    if (rechnung.editable) return;
    // Monatswechsel (Pfeile + Monats-Picker) ist eine Lese-Aktion und bleibt auch für
    // nur-lesende Benutzer aktiv.
    document.querySelectorAll('#vw-rechnung input:not(#rechnung-monat-input), #vw-rechnung select, #vw-rechnung button:not(.rechnung-monat-pfeil):not(.rechnung-mini-btn)').forEach((el) => {
        el.disabled = true;
    });
    // Für nur-lesende Benutzer leere/0-Konditionen ausblenden (bei Monatswechsel wieder
    // einblenden, falls im neuen Monat gesetzt). Mengenrabatt ist generell ausgeblendet
    // und wird hier daher nicht behandelt.
    ['r-Rabatt', 'r-Pauschale'].forEach((label) => {
        const zeile = feld(label)?.closest('.fieldset-div');
        if (zeile) zeile.style.display = numVal(label) === 0 ? 'none' : '';
    });
}

function speichereConfigDebounced() {
    clearTimeout(rechnung.configTimer);
    const zeitraum = zeitraumStr();
    rechnung.configTimer = setTimeout(() => stammdatenService.speichereRechnung({ ...leseConfig(), zeitraum }), 600);
}
function speichereSchulungenDebounced() {
    clearTimeout(rechnung.schulungTimer);
    rechnung.schulungTimer = setTimeout(() => stammdatenService.speichereSchulungen(leseSchulungen()), 600);
}
